import React from "react";
import { browserHistory } from "react-router";
import axios from "axios";
import logoImage from "../static/logo-payoff.svg";

export default class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      passAvailable: false,
      showInstructorPassMessage: false,
      passPDFUrl: null,
      passPDFError: null
    };
  }

  componentDidMount() {
    if (this.props.loggedIn) {
      this.checkForPass();
    }
  }

  // should be changed to getDerivedStateFromProps() if we ever upgrade to React 16
  componentWillReceiveProps(nextProps) {
    if (nextProps.loggedIn && this.props.loggedIn !== nextProps.loggedIn) {
      this.checkForPass();
    }
  }

  handleLogout() {
    axios.get("/v1/auth/logout/");
    localStorage.clear();
    browserHistory.push("/");
  }

  checkForPass() {
    const url = `${APP_CONFIG.api_url}/v1/instructors/self/passes/current/`;
    axios.get(url).then(response => {
      if (response.status === 200) {
        this.setState({
          passAvailable: response.data.state.state === 'ready',
        });
      } else {
        this.setState({ passAvailable: false });
      }
    }).catch(error => {
      this.setState({ passAvailable: false, passPDFError: 'unknown' });
      console.error('Error fetching pass:', error);
    });
  }

  showPass() {
    const show = (url) => window.open(url, '_blank');

    if (this.state.passPDFUrl) {
      // already fetched, show it
      show(this.state.passPDFUrl);
      return;
    }

    this.fetchPdf().then(url => {
      if (url) {
        show(url);
      }
      if (this.state.passPDFError) {
        this.setState({
          showInstructorPassMessage: !this.state.showInstructorPassMessage
        });
      }
    });
  }

  fetchPdf() {
    const url = `${APP_CONFIG.api_url}/v1/instructors/self/passes/current/download/`;
    return axios({
      url: url,
      method: 'GET',
      responseType: 'blob'
    }).then(response => {
      if (response.status === 200) {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const passPDFUrl = URL.createObjectURL(blob);
        this.setState({ passPDFUrl, passPDFError: null });
        return passPDFUrl;
      } else if (response.status === 404) {
        this.setState({ passPDFError: 'unavailable'});
      } else {
        this.setState({ passPDFError: 'unknown'});
      }
      return null;
    }).catch(error => {
      this.setState({ passPDFError: 'unknown' });
      console.error('Error fetching pass:', error);
      return null;
    });
}

  render() {
    let instructorPassPreview = this.state.showInstructorPassMessage ?
      <div className="instructor-pass-preview">
        {this.state.passPDFError === 'unavailable' && (
          <div className="preview-message">
            Instructeurspas (nog) niet beschikbaar.<br />
            Neem contact op met <a href="mailto:suppor@nibhv.nl?subject=Instructeurspas">support@nibhv.nl</a> voor meer informatie.
          </div>
        )}
        {this.state.passPDFError === 'unknown' && (
          <div className="preview-message">
            Er deed zich een fout voor bij het ophalen van de instructeurspas.<br />
            Neem contact op met <a href="mailto:suppor@nibhv.nl?subject=Instructeurspas">support@nibhv.nl</a> voor meer informatie.
          </div>
        )}
      </div>
      : null;

    return (
      <div className="site-header">
        <a href="/events">
          <img className="logo-payoff" src={logoImage} />
        </a>
        {this.props.loggedIn && <span className="content-right">
          {/* means we only show the toggle if there is an URL. All errors will never be seen */}
          {this.state.passAvailable && (
            <button onClick={() => this.showPass()}>
              {/* <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 1000 1000"><path d="M385.5 130.37v74.33H240.46c-93.01 0-148.45.8-154.28 2.21-29.73 6.83-57.65 31.34-70.71 62.27l-4.62 10.85-.6 289.07c-.6 318.8-1.21 301.12 12.05 324.22 7.83 13.86 24.11 30.13 38.17 38.17 23.1 13.26-6.63 12.46 439.53 12.46 446.16 0 416.43.8 439.53-12.46 14.06-8.04 30.33-24.31 38.17-38.17 13.26-23.1 12.66-5.42 12.05-324.22l-.6-289.07-4.62-11.05c-10.25-24.51-34.15-48.41-58.46-58.66l-11.25-4.62-150.06-.6-150.26-.6V56.04h-229v74.33zm168.74 70.31v84.37H445.76V116.31h108.48v84.37zM385.5 305.14v40.18h229v-80.36h146.84c164.52 0 157.09-.6 164.52 14.26 4.02 7.43 4.02 14.06 4.02 295.5 0 275.01-.2 288.26-3.62 294.69-2.01 3.82-6.83 8.64-10.65 10.65-6.43 3.42-23.5 3.62-415.62 3.62s-409.2-.2-415.62-3.62c-3.82-2.01-8.64-6.83-10.65-10.65-3.41-6.43-3.62-19.69-3.62-295.1s.2-288.67 3.62-295.1c2.01-3.82 6.83-8.64 10.65-10.65 6.43-3.41 15.27-3.62 153.88-3.62H385.5v40.2z"/><path d="M262.96 411.81c-15.87 3.01-37.57 15.27-51.02 28.73-28.32 28.12-37.77 65.09-25.11 98.83 2.41 6.23 3.82 11.45 3.41 11.65-.2.4-4.82 3.41-9.84 6.83-18.68 12.65-35.96 35.15-44.6 58.26-3.82 10.45-4.22 16.47-5.02 67.09l-.8 55.84H431.7v-49.02c0-26.92-.8-53.84-2.01-59.66-3.42-18.48-16.87-42.99-31.94-58.06-7.43-7.23-17.07-15.27-21.49-17.88l-8.04-4.42 4.62-13.46c11.45-33.75 2.21-66.89-26.52-96.02-24.3-24.69-53.23-34.54-83.36-28.71zm36.16 62.47c4.82 2.61 10.45 6.83 12.46 9.64 5.22 7.23 7.63 23.3 5.42 34.75-3.62 19.49-15.47 28.33-37.97 28.33-25.31 0-38.17-13.06-38.17-38.77 0-23.9 14.26-38.37 38.17-38.37 7.63 0 14.06 1.41 20.09 4.42zm-43.39 128.97c14.46 4.62 35.76 4.02 52.03-1.61 18.28-6.23 32.95-4.22 47.21 6.23 11.85 8.84 15.27 18.48 16.07 46.2l.8 24.71h-181.2v-21.29c0-11.85 1-24.91 2.21-29.13 2.81-9.44 12.25-20.89 20.29-25.11 8.04-4.22 21.69-6.43 27.72-4.62 2.82.8 9.45 3.01 14.87 4.62zM497.99 512.05v30.13h341.5v-60.26h-341.5v30.13zM497.99 636.6v30.13h162.72v-60.26H497.99v30.13z"/></svg> */}
              Instructeurspas
            </button>
          )}
          {instructorPassPreview}
          <a href="" onClick={this.handleLogout}>
            Uitloggen
          </a>
        </span>}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Header.js